import { ValuesOf } from '@/models/types';

export const CAPABILITY = {
    // APIKEY
    API_KEY_CREATE: 'API_KEY_CREATE',
    API_KEY_DELETE: 'API_KEY_DELETE',
    API_KEY_UPDATE: 'API_KEY_UPDATE',
    API_KEY_VIEW: 'API_KEY_VIEW',

    // CAPABILITY
    CAPABILITY_VIEW: 'CAPABILITY_VIEW',

    // COMPANY
    COMPANY_CREATE: 'COMPANY_CREATE',
    COMPANY_DELETE: 'COMPANY_DELETE',
    COMPANY_UPDATE: 'COMPANY_UPDATE',
    COMPANY_VIEW: 'COMPANY_VIEW',
    COMPANY_ALL: 'COMPANY_ALL',

    // COMPANY ABONOTEATRO
    COMPANY_ABONO_CREATE: 'COMPANY_ABONO_CREATE',
    COMPANY_ABONO_UPDATE: 'COMPANY_ABONO_UPDATE',
    COMPANY_ABONO_VIEW: 'COMPANY_ABONO_VIEW',

    // DISCOUNT
    DISCOUNT_CREATE: 'DISCOUNT_CREATE',
    DISCOUNT_DELETE: 'DISCOUNT_DELETE',
    DISCOUNT_UPDATE: 'DISCOUNT_UPDATE',
    DISCOUNT_VIEW: 'DISCOUNT_VIEW',

    // ENCLOSURE
    ENCLOSURE_CREATE: 'ENCLOSURE_CREATE',
    ENCLOSURE_DELETE: 'ENCLOSURE_DELETE',
    ENCLOSURE_UPDATE: 'ENCLOSURE_UPDATE',
    ENCLOSURE_VIEW: 'ENCLOSURE_VIEW',
    ENCLOSURE_ALL_COMPANIES: 'ENCLOSURE_ALL_COMPANIES',

    // ENCLOSURE TYPE
    ENCLOSURE_TYPE_CREATE: 'ENCLOSURE_TYPE_CREATE',
    ENCLOSURE_TYPE_DELETE: 'ENCLOSURE_TYPE_DELETE',
    ENCLOSURE_TYPE_UPDATE: 'ENCLOSURE_TYPE_UPDATE',
    ENCLOSURE_TYPE_VIEW: 'ENCLOSURE_TYPE_VIEW',

    // MARKET
    MARKET_CREATE: 'MARKET_CREATE',
    MARKET_DELETE: 'MARKET_DELETE',
    MARKET_UPDATE: 'MARKET_UPDATE',
    MARKET_VIEW: 'MARKET_VIEW',

    // PERSON
    PERSON_CREATE: 'PERSON_CREATE',
    PERSON_DELETE: 'PERSON_DELETE',
    PERSON_UPDATE: 'PERSON_UPDATE',
    PERSON_VIEW: 'PERSON_VIEW',

    // REPORT ACTION
    REPORT_ACTION_CREATE: 'REPORT_ACTION_CREATE',
    REPORT_ACTION_DELETE: 'REPORT_ACTION_DELETE',
    REPORT_ACTION_UPDATE: 'REPORT_ACTION_UPDATE',
    REPORT_ACTION_VIEW: 'REPORT_ACTION_VIEW',

    // REPORT
    REPORT_CONFIGURE: 'REPORT_CONFIGURE',
    REPORT_EXECUTE: 'REPORT_EXECUTE',
    REPORT_VIEW: 'REPORT_VIEW',

    // ROLE
    ROLE_CREATE: 'ROLE_CREATE',
    ROLE_DELETE: 'ROLE_DELETE',
    ROLE_MARKET_DELETE: 'ROLE_MARKET_DELETE',
    ROLE_UPDATE: 'ROLE_UPDATE',
    ROLE_VIEW: 'ROLE_VIEW',
    ROLE_PROPAGATE: 'ROLE_PROPAGATE',

    // SUBSCRIPTION
    SUBSCRIPTION_CREATE: 'SUBSCRIPTION_CREATE',
    SUBSCRIPTION_TYPE_CREATE: 'SUBSCRIPTION_TYPE_CREATE',
    SUBSCRIPTION_TYPE_DELETE: 'SUBSCRIPTION_TYPE_DELETE',
    SUBSCRIPTION_TYPE_UPDATE: 'SUBSCRIPTION_TYPE_UPDATE',
    SUBSCRIPTION_TYPE_VIEW: 'SUBSCRIPTION_TYPE_VIEW',
    SUBSCRIPTION_UPDATE: 'SUBSCRIPTION_UPDATE',
    SUBSCRIPTION_VIEW: 'SUBSCRIPTION_VIEW',

    // USER
    USER_CREATE: 'USER_CREATE',
    USER_DELETE: 'USER_DELETE',
    USER_UPDATE: 'USER_UPDATE',
    USER_VIEW: 'USER_VIEW',

    // TAX
    TAX_CREATE: 'TAX_CREATE',
    TAX_DELETE: 'TAX_DELETE',
    TAX_UPDATE: 'TAX_UPDATE',
    TAX_VIEW: 'TAX_VIEW',

    // EVENT
    EVENT_CREATE: 'EVENT_CREATE',
    EVENT_DELETE: 'EVENT_DELETE',
    EVENT_UPDATE: 'EVENT_UPDATE',
    EVENT_VIEW: 'EVENT_VIEW',

    // EVENT_ASSESSMENT (Valoraciones)
    EVENT_ASSESSMENT_VIEW: 'EVENT_ASSESSMENT_VIEW',
    EVENT_ASSESSMENT_CREATE: 'EVENT_ASSESSMENT_CREATE',
    EVENT_ASSESSMENT_UPDATE: 'EVENT_ASSESSMENT_UPDATE',

    // EVENT_CHANGE_STATUS (Cambiar estado publicado)
    EVENT_CHANGE_STATUS_PUBLISHED: 'EVENT_CHANGE_STATUS_PUBLISHED',
    // EVENT_CHANGE_STATUS_TO_PUBLISHED (Cambiar estado a publicado)
    EVENT_CHANGE_STATUS_TO_PUBLISHED: 'EVENT_CHANGE_STATUS_TO_PUBLISHED',

    // EVENT PRICES
    EVENT_PRICES_CREATE: 'EVENT_PRICES_CREATE',
    EVENT_PRICES_UPDATE: 'EVENT_PRICES_UPDATE',

    // SUBSCRIBER
    SUBSCRIBER_VIEW: 'SUBSCRIBER_VIEW',
    SUBSCRIBER_UPDATE: 'SUBSCRIBER_UPDATE',

    // PROVINCE
    PROVINCE_VIEW: 'PROVINCE_VIEW',

    // TOWNSHIP
    TOWNSHIP_VIEW: 'TOWNSHIP_VIEW',

    // INCIDENCE
    INCIDENCE_CREATE: 'INCIDENCE_CREATE',
    INCIDENCE_UPDATE: 'INCIDENCE_UPDATE',
    INCIDENCE_VIEW: 'INCIDENCE_VIEW',

    // NOTIFICATION
    NOTIFICATION_CREATE: 'NOTIFICATION_CREATE',
    NOTIFICATION_UPDATE: 'NOTIFICATION_UPDATE',
    NOTIFICATION_VIEW: 'NOTIFICATION_VIEW',

    // CAPABILITY
    CAPABILITY_CREATE: 'CAPABILITY_CREATE',
    CAPABILITY_DELETE: 'CAPABILITY_DELETE',
    CAPABILITY_UPDATE: 'CAPABILITY_UPDATE',
    CAPABILITY_PROPAGATE: 'CAPABILITY_PROPAGATE',

    // CMS
    CMS_UPDATE: 'CMS_UPDATE',
    CMS_VIEW: 'CMS_VIEW',

    // OPERATION
    OPERATION_RESEND: 'OPERATION_RESEND',
    OPERATION_RETURN: 'OPERATION_RETURN',
    OPERATION_UPDATE: 'OPERATION_UPDATE',
    OPERATION_VIEW: 'OPERATION_VIEW',

    // TEMPLATE
    TEMPLATE_CREATE: 'TEMPLATE_CREATE',
    TEMPLATE_DELETE: 'TEMPLATE_DELETE',
    TEMPLATE_UPDATE: 'TEMPLATE_UPDATE',
    TEMPLATE_VIEW: 'TEMPLATE_VIEW',
} as const;

export type Capability = ValuesOf<typeof CAPABILITY>;
